import React from 'react';
import ReactDOM from 'react-dom/client';
import './themes/orgThemes.css';
import './themes/phishingbox-overrides.css';
import './index.css';
import App from './App';

// Suppress ResizeObserver errors (common with React Data Grid, harmless)
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop')
  ) {
    return;
  }
  originalError.call(console, ...args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

